import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const ProgressContainer = styled('div')<{ $flexDirection?: 'row' | 'column' }>`
  display: flex;

  ${({ $flexDirection }) =>
    `
      flex-direction: ${$flexDirection};
      align-items: ${$flexDirection === 'column' ? 'start' : 'center'};
    `}
`

export const ProgressLabel = styled(Typography)`
  color: ${colors.pink};
  margin-right: 10px;
`
